import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { MdClose, MdFlag } from 'react-icons/md';
import './ReportModal.css';
import { createReport } from '../../../api/services/reportService';

const ReportModal = ({ isOpen, onClose, propertyId, propertyName, onReportSuccess }) => {
  const [category, setCategory] = useState('MAINTENANCE');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title.trim()) {
      setError('Please provide a title for the report.');
      return;
    }

    if (!description.trim()) {
      setError('Please provide a description.');
      return;
    }

    const payload = {
      level: 'ADMIN',
      category: category,
      title: title.trim(),
      description: description.trim(),
      propertyId: propertyId,
    };

    console.log('[ReportModal] Submitting report with payload:', payload);

    setSubmitting(true);
    setError('');

    try {
      const response = await createReport(payload);
      if (onReportSuccess) {
        onReportSuccess(response.message || 'Report submitted to Admin.');
      }
      onClose();
    } catch (err) {
      console.error('[ReportModal] Error:', err);
      setError(err.message || 'Failed to submit report. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return createPortal(
    <div className="report-modal-overlay" onClick={onClose}>
      <div className="report-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="report-modal-header">
          <div className="report-modal-title">
            <MdFlag className="report-icon" />
            <h2>Report Issue / Property</h2>
          </div>
          <button className="close-btn" onClick={onClose} aria-label="Close modal">
            <MdClose />
          </button>
        </div>

        <div className="report-modal-subtitle">
          Reporting for: <strong>{propertyName || 'this property'}</strong>
        </div>

        <form onSubmit={handleSubmit} className="report-modal-form">
          <div className="form-group">
            <label htmlFor="report-category">Category</label>
            <select
              id="report-category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              disabled={submitting}
            >
              <option value="MAINTENANCE">Maintenance Issue</option>
              <option value="BEHAVIOUR">Behaviour / Conduct</option>
              <option value="SCAM">Scam / Fraud</option>
              <option value="OVERCHARGE">Overcharging / Finance</option>
              <option value="OTHER">Other</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="report-title">Title</label>
            <input
              id="report-title"
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g. Leaking roof, Broken door"
              disabled={submitting}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="report-description">Detailed Description</label>
            <textarea
              id="report-description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Provide more details about the issue..."
              rows="5"
              disabled={submitting}
              required
            />
          </div>

          {error && <div className="report-error-message">{error}</div>}

          <div className="report-modal-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={submitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn-primary report-submit-btn"
              disabled={submitting}
            >
              {submitting ? 'Submitting...' : 'Submit to Admin'}
            </button>
          </div>
        </form>
      </div>
    </div>,
    document.body
  );
};

export default ReportModal;
